var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.99076,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0001 5.2793C18.5688 5.2793 20.6512 7.36599 20.6512 9.94006V13.7515C20.6512 16.2995 18.549 18.3294 16.0001 18.3294C13.4511 18.3294 11.3489 16.2995 11.3489 13.7515V10.8722L10.1529 10.8722L7.04542 9.00791H11.442C11.8729 6.88051 13.7499 5.2793 16.0001 5.2793ZM18.7908 10.8722L18.7908 13.7515C18.7908 15.2306 17.5611 16.4651 16.0001 16.4651C14.439 16.4651 13.2094 15.2306 13.2094 13.7515V10.8722L18.7908 10.8722Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2326 24.6474C26.2326 22.8169 21.6513 19.2616 16.0001 19.2616C10.3488 19.2616 5.76758 22.8169 5.76758 24.6474L5.76758 26.7188H26.2326L26.2326 24.6474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/imagePlaceholder.92595f00dfb56823c0bd3dc87f687c96.svg";
export { ForwardRef as ReactComponent };